import { inject, Injectable } from "@angular/core";
import {
  PageViewInferface,
  SetEventInterface,
} from "../interfaces/tagging.interface";
import { StorageService } from "@tae/services";
import { flowsOption, pathsTaggeo } from "../fixtures/tagging.fixture";
import { CtrlRechargeService } from "./ctrl-recharge/ctrl-recharge.service";
import { Accounts } from "@tae/interfaces";
import { TitleOptionEnum } from "../enums/title-option.enum";
import { PathsTaggeoEnum } from "../enums/paths-taggeo.enum";
import { RechargeInterface } from "../interfaces/ctrl-recharge.interface";

declare global {
  interface Window {
    dataLayer: Array<PageViewInferface | SetEventInterface>;
  }
}

@Injectable({
  providedIn: "root",
})
export class TaggingService {
  storageService = inject(StorageService);
  ctrlRecharge = inject(CtrlRechargeService);
  lastRechargeData = {
    marca: "",
    monto: "",
    plan: "",
  };

  public get accounts(): Accounts[] {
    return this.ctrlRecharge.accounts;
  }

  public get recharge(): RechargeInterface {
    return this.ctrlRecharge.recharge;
  }

  constructor() {
    console.log(window.dataLayer);
    if (!window?.dataLayer?.length) {
      window.dataLayer = [];
    }
     console.log(window.dataLayer);
  }

  setPageView(pageView: PageViewInferface) {
    this.lastRecharge();
    let typeUser: string =
      this.accounts === undefined
        ? ""
        : this.accounts.length > 1
        ? "multiproducto"
        : "monoproducto";
    let userId = this.storageService.get("anonimized");
    const versionApp = this.storageService.get('appversion');
    window.dataLayer.push({
      url: pageView.url,
      titulo: pageView.titulo,
      canalBanco: pageView.canalBanco,
      subsection1: pageView.subsection1,
      versionApp: versionApp || pageView.versionApp,
      userId: userId,
      entorno: pageView.entorno,
      proceso: pageView.proceso || "recarga_celular",
      periodicidad: pageView.periodicidad,
      marca: pageView.marca || this.lastRechargeData.marca,
      monto: pageView.monto || this.lastRechargeData.monto,
      plan: pageView.plan || this.lastRechargeData.plan,
      tipoUsuario: typeUser,
      event: pageView.event,
    });
  }

  setEvent(action: SetEventInterface) {
    let userId = this.storageService.get("anonimized");
    window.dataLayer.push({
      event: action.event,
      categoria: action.categoria,
      accion: action.accion,
      etiqueta: action.etiqueta,
      canalBanco: action.canalBanco,
      url: action.url,
      userID: userId,
    });
  }

  alternateFlows(data: string) {
    if (data === "error") {
      return null;
    }
    const find = Object.entries(TitleOptionEnum).find(([key, value]) => {
      return data === value;
    });
    const event = flowsOption.get(
      TitleOptionEnum[find[0] as keyof typeof TitleOptionEnum]
    );
    this.setEvent(event);
  }

  getError(isError: boolean, data: any) {
    if (!isError) {
      if (data.flow) {
        this.alternateFlows(TitleOptionEnum.off);
        return;
      }
      if (data.title) {
        const title = data?.confirmRechargeSchedule ? TitleOptionEnum.scheduleConfirm : data.title; 
        this.alternateFlows(title);
      } else {
        let error = data?._data?.message ? true : false;

        !error
          ? this.alternateFlows(data.labels.titleDialog)
          : this.alternateFlows("error");
      }
    }
  }

  errorsFlows(path: string) {
    const find = Object.entries(PathsTaggeoEnum).find(([key, value]) => {
      return path === value;
    });
    const event = pathsTaggeo.get(PathsTaggeoEnum[find[0]]);
    return event;
  }

  lastRecharge() {
    if (this.recharge.biller && this.recharge.amount) {
      this.lastRechargeData.marca = this.recharge.biller.name;
      this.lastRechargeData.monto = this.recharge.amount.toString();
      this.lastRechargeData.plan =
        this.recharge.biller?.category?.toLocaleLowerCase?.();
    }
  }
}
